import React, { useMemo } from "react"
import { observer } from "mobx-react-lite"
import { useIntl } from "react-intl"
import { Table, TTableOnFetch } from "@btc-alpha/ui-components"

import { TWithdraw } from "types/withdrawal"
import historyMessages from "messages/history"
import { useRatesUSDT } from "services/AccountService"
import WithdrawalService from "services/WithdrawalService"
import useModal from "hooks/useModal"
import useWindowSize from "hooks/useWindowSize"
import { useColumns, useFilters } from "./hooks"
import WithdrawalDetails from "../../Withdrawal/WithdrawalDetails"

const Withdrawals = () => {
	const { formatMessage } = useIntl()
	const { smallTablet } = useWindowSize()
	const filters = useFilters()
	const columns = useColumns()
	const { data } = useRatesUSDT()

	const handleFetch: TTableOnFetch<TWithdraw> = async ({ page, limit, filters }) => {
		const { results, count } = await WithdrawalService.getPreviousWithdraws({
			page,
			"page-size": limit,
			currency: filters.currency,
		})
		return { data: results, count }
	}

	const [openDetailsModal] = useModal(WithdrawalDetails, {
		width: 500,
		closeBack: true,
		closeEsc: true,
		closeButton: true,
	})

	const rates = useMemo(() => {
		const result = new Map<string, number>()
		data?.forEach(({ currency, rate }) => result.set(currency, rate))
		return result
	}, [data])

	const extractAddress = (withdraw: TWithdraw): string =>
		withdraw.attributes?.find(({ label }) => label.toLowerCase() === "address")?.value || ""

	const handleRowClick = (row: TWithdraw) => {
		if (!row) {
			console.log("No withdrawal data found")
			return
		}

		openDetailsModal({
			amount: row.amount,
			currency: row.currency.code,
			rate: rates.get(row.currency.code) || 0,
			status: row.status,
			date: row.date,
			address: extractAddress(row),
			txid: row.txid,
			note: row.note,
		})
	}

	return (
		<Table
			columns={columns}
			filters={filters}
			empty={formatMessage(historyMessages.no_orders_to_show)}
			lazyLoad
			resetFilters
			defFetching
			footer="pagination"
			onFetch={handleFetch}
			onRowClick={smallTablet ? handleRowClick : undefined}
		/>
	)
}

export default observer(Withdrawals)
